export const vehicle = {
  newFleet: "New Fleet",
  editFleet: "Edit Fleet",
  newVehicle: "New Vehicle",
  editVehicle: "Edit Vehicle",
  vehicleInformation: "Vehicle Information",
  fleetNameOrVehicleID: "Fleet Name or Vehicle ID",
  fleetDetails: "Fleet Details",
  vehicleDetails: "Vehicle Details",
  // Format: type ["detail1", "detail2", ......]
  fleetDeleteTip:
    "The fleet {0} will be deleted. Are you sure you want to proceed? | The fleets {0} will be deleted. Are you sure you want to proceed?",
  // Format: type ["detail1", "detail2", ......]
  vehicleDeleteTip:
    "The vehicle {0} will be deleted. Are you sure you want to proceed? | The vehicles {0} will be deleted. Are you sure you want to proceed?",
  pleaseInputFleetName: "Please input a fleet name",
  pleaseInputDutyDayOfWeek: "Please select the working days for this fleet",
  pleaseInputVehicleID: "Please input a vehicle ID",
  pleaseSelectFleet: "Please select a fleet",
  pleaseSelectVehicleModel: "Please select a vehicle model or create a new one",
  pleaseSelectWiFiMode: "Please select a Wi-Fi mode",
  unbindDeviceSuccessfully:
    "The system has been unregistered from the vehicle.",
  failedToUnbindDevice: "Failed to unregister the system from the vehicle.",
  unregister: "Unregister",
  unbindTip:
    "If the system is unregistered from the vehicle, data will longer be sent to the cloud.",
  failedToSaveFleetNameAlreadyExist:
    "Failed to save. The fleet name already exists.",
  failedToSaveVehicleIDAlreadyExist:
    "Failed to save. The vehicle ID already exists.",
  failedToAddAuthorizedDrivers:
    "Failed to add authorized drivers. Please refresh the page to get the latest driver list.",
  syncWithCloud: "Sync with System Settings",
  syncedWithCloud: "Sync with System Settings successfully.",
  FailedToSyncWithCloud: "Failed to sync with System Settings.",
  pleaseInputWorkingHours: "Please select the working hours for this fleet",
  invalidWorkingHours: "Invalid working hours",
  pleaseInputNextMaintenanceTime: "Please input next maintenance date",
  nextVehicleCheckTime: "Inspection Valid Until",
  nextMaintenanceTime: "Next Maintenance Date",
  pleaseInputSpeedLimit: "Please input maximum speed limit",
  pleaseInputTireDimension: "Please input tireDimension",
};
